import React, { useEffect, useRef, useState } from "react";
import "./home.scss";
import Slider from "react-slick";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import AnimatedNumbers from "react-animated-numbers";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { Link, useNavigate } from "react-router-dom";
import Meta from "../../Components/Meta";
import PropTypes from "prop-types";
import Feedback from "../../Components/Common/Feedback";
import OfferProduct from "../../Components/Common/OfferProduct";
import Modal from "@mui/material/Modal";
// import ReactPlayer from 'react-player'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3, minHeight: "470px" }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  value: PropTypes.number.isRequired,
  index: PropTypes.number.isRequired,
};

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  overflow: "auto",
  transform: "translate(-50%, -50%)",
  width: {
    xs: "90%", // mobile
    sm: "80%", // tablets
    md: 600, // medium screens
    lg: 800, // large screens
    xl: 900,
  },
  height: "500px",
  bgcolor: "#f3f3ec",
  p: 4,
};

const Landing = () => {
  const theme = useTheme();

  const router = useNavigate();

  const [value, setValue] = useState(1);
  const [currentSlide, setCurrentSlide] = useState(0);

  const [PriceOpen, setPriceOpen] = useState(false);
  const handleOpenPrice = () => setPriceOpen(true);
  const handleClosePrice = () => setPriceOpen(false);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const settings3 = {
    dots: false,
    infinite: true,
    autoplay: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    initialSlide: 0,
    beforeChange: (oldIndex, newIndex) => {
      setCurrentSlide(newIndex);
    },
    afterChange: (index) => {
      setCurrentSlide(index);
    },
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
          // autoplay: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          // autoplay: true,
          initialSlide: 2,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  const settings2 = {
    dots: false,
    infinite: true,
    autoplay: true,
    cssEase: "linear",
    autoplaySpeed: 4000,
    speed: 2000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
          infinite: true,
          dots: false,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: false,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: false,
        },
      },
    ],
  };

  const slider1 = useRef(null);

  const words = [
    "dining delight",
    "beauty and glow",
    "style and store",
    "food and flair",
    "coffee and chat",
    "wellness and care",
    "service and speed",
    "brands that fly",
  ];
  const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setFade(false);

      setTimeout(() => {
        setIndex((prev) => (prev + 1) % words.length);
        setFade(true);
      }, 500);
    }, 2500);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Meta
        title={"Fusion: Bespoke Tools for Every Business Type & Size"}
        desc={
          "Streamline sales, payments, and operations with Fusion’s powerful POS systems, payment devices, and online ordering tools. Perfect for UK businesses."
        }
        url={window.location.href}
        keywords={
          "POS system UK, payment solutions, Fusion POS, online ordering system, restaurant POS, retail POS, contactless payments, card machine UK, e-commerce integration, self-service kiosk"
        }
      />

      <section>
        <div className="position-relative ">
          <div className="d-md-flex d-none mob_bak1">
            <video
              autoPlay
              muted
              playsInline
              loop
              width="100%"
              poster="/assets/img/landing/cover-d.webp"
              className=""
            >
              <source src={"https://fusionbucket.co.uk/FMB/homepage/land_hero.webm"} type="video/webm"></source>
              { /* <source src={"/assets/land_hero.webm"} type="video/webm"></source> */}
            </video>
          </div>
          <div className="d-md-none mob_bak">
            <video
              autoPlay
              muted
              loop
              playsInline
              poster="/assets/img/landing/cover.jpg"
              width="100%"
              className=""
            >
              <source src={"https://fusionbucket.co.uk/FMB/homepage/mobile_v.mp4"} type="video/mp4"></source>
              {/* <source src={"/assets/mobile_v.mp4"} type="video/mp4"></source> */}
              {/* <source src={"/assets/mobile_v.webm"} type="video/webm"></source> */}
            </video>
          </div>
          <div className="top_banner ne_ul position-absolute  col-lg-8 text-start ">
            <div className="container">
              <div className="top-alio">
                <div className="mb-4 mt-sm-0 mt-3">
                  <h2 className="text-white mb-2 ps-1">Be the next.</h2>
                  <h1 className="text-white pt-0 mb-2">Big thing in</h1>
                  <div className="aol_p2">
                    <div className="fade-text-container text-start">
                      <span
                        className={`swipe-text ${
                          fade ? "swipe-in" : "swipe-out"
                        }`}
                      >
                        <h1 className="two_line text-white lh-sm">
                          {words[index]}
                        </h1>
                      </span>
                    </div>
                  </div>
                </div>
                <div className="mob-res">
                  <h4 className="text-white mb-4">
                    All-in-one | Free to start | Made to grow.
                  </h4>
                  <div className="d-flex flex-wrap justify-content-start gap-2 mb-5">
                    <button
                      className="btn btn-wl"
                      type="button"
                      onClick={() => router("/get-started")}
                    >
                      Get Start Free
                    </button>
                    <button
                      className="btn btn-wl2"
                      type="button"
                      onClick={() => router("/get-started")}
                    >
                      Watch Demo
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div className="shaow-tyl d-lg-block d-none"></div> */}
        </div>

        <div className="top_banner pos-top1 pt-0">
          <div data-aos="zoom-out-up" className=" top_im pt-3">
            <Slider autoplay={false} {...settings3}>
              <div>
                <img
                  loading="lazy"
                  alt="fusion"
                  src="https://fusionbucket.co.uk/FMB/homepage/heroL1.webp"
                  // src="/assets/img/landing/heroL1.webp"
                  className=""
                />
              </div>
              <div>
                <img
                  loading="lazy"
                  alt="fusion"
                  src="https://fusionbucket.co.uk/FMB/homepage/heroL2.webp"
                  // src="/assets/img/landing/heroL2.webp"
                  className=""
                />
              </div>
            </Slider>
          </div>
          <div className="container pt-3 pb-2">
            <div className="d-flex justify-content-center gap-3 align-items-center mb-3 payj overflow-auto">
              <img
                loading="lazy"
                src="/assets/img/svg/American Express Icon.svg"
                className=""
                alt="fusion"
              />
              <img
                loading="lazy"
                src="/assets/img/svg/Apple Pay Icon.svg"
                className=""
                alt="fusion"
              />
              <img
                loading="lazy"
                src="/assets/img/svg/Google Pay Icon.svg"
                className=""
                alt="fusion"
              />
              <img
                loading="lazy"
                src="/assets/img/svg/Master Card Icon.svg"
                className=""
                alt="fusion"
              />
              <img
                loading="lazy"
                src="/assets/img/svg/Visa Card Icon.svg"
                className=""
                alt="fusion"
              />
              <img
                loading="lazy"
                src="/assets/img/svg/WireLess Payment Icon.svg"
                className=""
                alt="fusion"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="pos1">
        <div className="container">
          <Box sx={{ width: "100%" }}>
            <Tabs value={value} onChange={handleChange}>
              <Tab
                value={1}
                sx={{
                  fontSize: "1rem",
                  fontWeight: "600",
                }}
                label="Hospitality"
              />
              <Tab
                value={2}
                sx={{
                  fontSize: "1rem",
                  fontWeight: "600",
                }}
                label="Retail"
              />
              <Tab
                value={3}
                sx={{
                  fontSize: "1rem",
                  fontWeight: "600",
                }}
                label="Beauty"
              />
            </Tabs>

            <TabPanel value={value} index={1} dir={theme.direction}>
              <div className="tab-sce text-start">
                <div className="row">
                  <div data-aos="fade-right" className="col-lg-6 mb-3">
                    <h2 className="fw-bolder">
                      Made for food. Built for ease.
                    </h2>

                    <p>
                      Run your entire restaurant from one powerful platform—POS,
                      payments, online ordering, inventory, and staff
                      management. Simplify operations and serve your customers
                      better, all in one place.
                    </p>

                    <div className="d-flex flex-wrap justify-content-start gap-2 mb-4">
                      <button
                        //  data-aos="fade-right"
                        className="btn btn-gd"
                        type="button"
                        onClick={() => router("/restaurant-pos")}
                      >
                        Point of Sale
                      </button>
                      <button
                        // data-aos="fade-left"
                        className="btn btn-gd"
                        type="button"
                        onClick={() => router("/best-online-ordering")}
                      >
                        Online Ordering
                      </button>
                      <button
                        // data-aos="fade-left"
                        className="btn btn-gd"
                        type="button"
                        onClick={() => router("/payments/proPay")}
                      >
                        Payment Terminal
                      </button>
                    </div>
                    <Link to="/restaurant-overview" className="text-color">
                      Learn more <ArrowOutwardIcon />
                    </Link>
                  </div>

                  <div className="col-lg-6 mb-3 ">
                    <div className="fdi-tab">
                      <div className="w-100 d-flex align-items-center justify-content-center">
                        <img
                          loading="lazy"
                          src="/assets/img/Restaurant C20.webp"
                          // src="/assets/img/pos23.webp"
                          alt="fusion"
                          className="w-100"
                          data-aos="zoom-in"
                        />
                      </div>

                      <div className="mi-s w-100">
                        <img
                          loading="lazy"
                          alt="Restaurant POS software for takeaway and dine-in"
                          data-aos="fade-right"
                          src="/assets/img/Restaurant-M20.webp"
                        />
                      </div>

                      <div className="side_img w-100">
                        <img
                          loading="lazy"
                          data-aos="fade-left"
                          src="/assets/img/fi1.webp"
                          alt="fusion"
                          className="w-100"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={2} dir={theme.direction}>
              <div className="tab-sce text-start">
                <div className="row">
                  <div data-aos="fade-right" className="col-lg-6 mb-3">
                    <h2 className="fw-bolder">
                      Retail, reimagined beautifully.
                    </h2>
                    <p>
                      Retail tech that works as hard as you do. Powerful tools
                      to sell faster, track smarter, and grow bigger.
                      All-in-one, effortless — made to transform your business.
                    </p>
                    <div className="d-flex flex-wrap justify-content-start gap-2 mb-4">
                      <button
                        //  data-aos="fade-right"
                        className="btn btn-bl"
                        type="button"
                        onClick={() => router("/pos-system")}
                      >
                        Point of Sale
                      </button>
                      <button
                        // data-aos="fade-left"
                        className="btn btn-bl"
                        type="button"
                        onClick={() => router("/online-ordering")}
                      >
                        Online Ordering
                      </button>
                      <button
                        // data-aos="fade-left"
                        className="btn btn-bl"
                        type="button"
                        onClick={() => router("/payments/proPay")}
                      >
                        Payment Terminal
                      </button>
                    </div>
                    <Link to="/retail-pos" className="text-color">
                      Learn more <ArrowOutwardIcon />
                    </Link>
                  </div>
                  <div className="col-lg-6 mb-3 fdi-tab">
                    <div className="w-100 d-flex align-items-center justify-content-center">
                      <img
                        loading="lazy"
                        src="/assets/img/Retail C20.webp"
                        // src="/assets/img/po24.webp"
                        alt="fusion"
                        data-aos="zoom-in"
                        className="w-100 "
                      />
                    </div>
                    <div className="mi-s w-100">
                      <img
                        loading="lazy"
                        alt="Barcode scanning and checkout"
                        data-aos="fade-right"
                        src="/assets/img/Retail M20.webp"
                      />
                    </div>
                    <div className="side_img w-100">
                      <img
                        loading="lazy"
                        data-aos="fade-left"
                        src="/assets/img/fi2.webp"
                        alt="fusion"
                        className="w-100"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
            <TabPanel value={value} index={3} dir={theme.direction}>
              <div className="tab-sce text-start">
                <div className="row">
                  <div data-aos="fade-right" className="col-lg-6 mb-3">
                    <h2 className="fw-bolder">Made to match your style.</h2>
                    <p>
                      Accept payments effortlessly, manage your calendar, and
                      attract new clients—all while keeping your team connected.
                      Everything you need to run your business smoothly, in one
                      simple platform.
                    </p>
                    <div className="d-flex flex-wrap justify-content-start gap-2 mb-4">
                      <button
                        //  data-aos="fade-right"
                        className="btn btn-bl"
                        type="button"
                        onClick={() => router("/beauty")}
                      >
                        Point of Sale
                      </button>
                      <button
                        // data-aos="fade-left"
                        className="btn btn-bl"
                        type="button"
                        onClick={() => router("/beauty")}
                      >
                        Online Ordering
                      </button>
                      <button
                        // data-aos="fade-left"
                        className="btn btn-bl"
                        type="button"
                        onClick={() => router("/payments/proPay")}
                      >
                        Payment Terminal
                      </button>
                    </div>
                    <Link to="/beauty" className="text-color">
                      Learn more <ArrowOutwardIcon />
                    </Link>
                  </div>
                  <div className="col-lg-6 mb-3 fdi-tab">
                    <div className="w-100 d-flex align-items-center justify-content-center">
                      <img
                        loading="lazy"
                        src="/assets/img/Beauty-iPadl.webp"
                        alt="fusion"
                        data-aos="zoom-in"
                        className="w-100 "
                      />
                    </div>
                    <div className="mi-s w-100">
                      <img
                        loading="lazy"
                        alt="fusion"
                        data-aos="fade-right"
                        src="/assets/img/Beauty-S700.webp"
                      />
                    </div>
                    <div className="side_img w-100">
                      <img
                        loading="lazy"
                        data-aos="fade-left"
                        src="/assets/img/fi3.webp"
                        alt="fusion"
                        className="w-100"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </TabPanel>
          </Box>
        </div>
      </section>

      <section className="choosh_prod">
        <div className="container">
          <div className="text-start">
            <h2 className="fw-bold">Choose products based on your needs</h2>
            <hr className="hr" />
          </div>

          <div className="slider-container appi">
            <Slider ref={slider1} {...settings}>
              <div
                data-aos="zoom-in"
                onClick={() => router("/pos-system")}
                className="slide-op"
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Point of sale.webp"
                  // src="/assets/img/landing/Point of sale.webp"
                  className=""
                  alt="POS for restaurants and retail"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Point Of Sale</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                onClick={() => router("/payments/proPay")}
                className="slide-op"
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Business card terminal.webp"
                  // src="/assets/img/landing/Business card terminal.webp"
                  className=""
                  alt="Business card payment terminal"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Business Card Terminal</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                onClick={() => router("/payments")}
                className="slide-op"
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Mobile App.webp"
                  // src="/assets/img/landing/Mobile App.webp"
                  className=""
                  alt="Business tracking on mobile"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Mobile App</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                onClick={() => router("/online-ordering")}
                className="slide-op"
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Order Online.webp"
                  // src="/assets/img/landing/Order Online.webp"
                  className=""
                  alt="Online ordering system for restaurants"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Order Online</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                onClick={() => router("/self-serve-kiosks")}
                className="slide-op"
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Kiosk.webp"
                  // src="/assets/img/landing/Kiosk.webp"
                  className=""
                  alt="Touch-screen ordering system"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Kiosk</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op"
                onClick={() => router("/industries/market-stall")}
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Restaurant Marketing.webp"
                  // src="/assets/img/landing/Restaurant Marketing.webp"
                  className=""
                  alt="Fusion POS loyalty and promotions"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Marketing Promotional</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op"
                onClick={() => router("/restaurant-pos")}
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Run your business.webp"
                  // src="/assets/img/landing/Run your business.webp"
                  className=""
                  alt="All-in-one POS management system"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Run Your Business</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op h-100 rounded-4"
                //  color_b
                onClick={() => router("/business-account")}
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/account.webp"
                  // src="/assets/img/landing/account.webp"
                  className=""
                  alt="Real-time financial tracking for businesses"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Business Account</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op h-100 rounded-4 "
                //  color_y
                onClick={() => router("/cash-advance")}
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Cash Advanche.webp"
                  // src="/assets/img/landing/Cash Advanche.webp"
                  className=""
                  alt="Fusion Merchant Cash Advance"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Cash Advance</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op h-100 rounded-4 "
                //  color_o
                onClick={() => router("/visacard")}
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Fusion card.webp"
                  // src="/assets/img/landing/Fusion card.webp"
                  className=""
                  alt="Fusion Card gift and reward payments"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Fusion Card</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op"
                onClick={() => router("/best-online-ordering")}
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Order management.webp"
                  // src="/assets/img/landing/Order management.webp"
                  className=""
                  alt="Dine-in and takeaway order tracking"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Order Management </h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op  h-100 rounded-4 "
                // color_b
                onClick={() => router("/inventory-management")}
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Inventory Management.webp"
                  // src="/assets/img/landing/Inventory Management.webp"
                  className=""
                  alt="Inventory control for restaurants and retail"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Inventory Management</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                onClick={() => router("/kitchen-display")}
                className="slide-op"
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/kitchen.webp"
                  // src="/assets/img/landing/kitchen.webp"
                  className=""
                  alt="Real-time kitchen order tracking"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Kitchen Display System</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op h-100 rounded-4 "
                onClick={() => router("/pos-system")}
                // color_o
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Scanner.webp"
                  // src="/assets/img/landing/Scanner.webp"
                  className=""
                  alt="Retail and hospitality barcode system"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Scanner</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op h-100 rounded-4 "
                onClick={() => router("/pos-system")}
                // color_g
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Staff Management.webp"
                  // src="/assets/img/landing/Staff Management.webp"
                  className=""
                  alt="POS with access control features"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Staff Management</h4>
                </div>
              </div>

              <div
                data-aos="zoom-in"
                className="slide-op h-100 rounded-4 "
                // color_b
                onClick={() => router("/pos-system")}
              >
                <img
                  loading="lazy"
                  src="https://fusionbucket.co.uk/FMB/homepage/Appoinments.webp"
                  // src="/assets/img/landing/Appoinments.webp"
                  className=""
                  alt="Real-time booking management"
                />
                <div className="slide-up">
                  <h4 className="fw-bold">Appointments</h4>
                </div>
              </div>
            </Slider>
            <div className="mt-4 d-flex justify-content-end">
              <div className="d-flex gap-3">
                <button
                  // role="button"
                  type="button"
                  disabled={currentSlide === 0}
                  onClick={() => slider1?.current?.slickPrev()}
                  className="arr-85"
                >
                  <ArrowBackIcon />
                </button>
                <button
                  type="button"
                  // role="button"
                  disabled={currentSlide === 12}
                  onClick={() => slider1?.current?.slickNext()}
                  className="arr-85"
                >
                  <ArrowForwardIcon />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="p-2 transpre">
        <div data-aos="fade-up" className="container">
          <div>
            <h1>
              <span className="fw-bold">
                Save More with Truly Transparent Pricing
              </span>{" "}
            </h1>
            <p>
              No sneaky fees, no annual costs, and zero minimums. Keep your
              profits where they belong—in your pocket, not ours.
            </p>
          </div>

          <div className="row text-center perse pb-2">
            <div className="col-lg-6">
              <div>
                <h4 className="mt-3 mb-4 fw-bold">In-person transactions</h4>
                <div className="d-flex gap-1 justify-content-center align-items-end">
                  <small className="mb-md-4">from</small>
                  <h1 className="fw-bolder justify-content-center d-md-flex d-none">
                    <AnimatedNumbers
                      includeComma
                      className="priceSymbol"
                      transitions={(index) => ({
                        type: "spring",
                        duration: index + 0.3,
                      })}
                      animateToNumber={0.39}
                    />
                    %
                  </h1>
                  <h1 className="fw-bolder mb-2 d-md-none d-flex">0.39%</h1>
                </div>
                <p>When card is present</p>
              </div>
            </div>
            <div className="col-lg-6">
              <div>
                <h4 className="mt-3 mb-4 fw-bold">Online & Manual Entry</h4>
                <div className="d-flex gap-1 justify-content-center align-items-end">
                  <small className="mb-md-4">from</small>
                  <h1 className="fw-bolder justify-content-center d-md-flex d-none">
                    <AnimatedNumbers
                      includeComma
                      className="priceSymbol"
                      transitions={(index) => ({
                        type: "spring",
                        duration: index + 0.3,
                      })}
                      animateToNumber={2.4}
                    />{" "}
                    %
                  </h1>
                  <h1 className="fw-bolder mb-2 d-md-none d-flex">2.4%</h1>
                </div>
                <p>Online transactions and when card is not present</p>
              </div>
            </div>
          </div>

          <div className="d-flex flex-wrap align-items-center justify-content-center gap-2 mt-2 mb-3">
            <button
              className="btn btn-sn"
              onClick={() => router("/get-started")}
              type="button"
            >
              Get Custom Price
            </button>
            <button
              className="btn btn-gd"
              onClick={() => handleOpenPrice()}
              type="button"
            >
              How our rates work 
              {/* <ArrowOutwardIcon /> */}
            </button>
          </div>
        </div>

        <Modal
          keepMounted
          open={PriceOpen}
          onClose={handleClosePrice}
          aria-labelledby="keep-mounted-modal-title"
          aria-describedby="keep-mounted-modal-description"
        >
          <Box sx={style} className="text-center rounded-3">
            <div className="modal-P text-start">
              <div className="pos_tile">
                <h2 className="mb-3">Debit & Credit Transaction Fees</h2>
                <h5 className="mb-3">
                  Applicable to customers with an annual card turnover of less
                  than £200k.
                </h5>
              </div>
              <hr />
              <div className="mb-3">
                <p className="fw-bold">Debit cards (per transaction)</p>

                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/visa-DfUGj4HW.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Visa</p>
                  </div>
                  <p className="mb-0 fw-normal">0.39%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/maestro-CA-oqUvT.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Maestro</p>
                  </div>
                  <p className="mb-0 fw-normal">0.39%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/download.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Mastercard</p>
                  </div>
                  <p className="mb-0 fw-normal">0.39%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/download (1).png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">All other debit cards</p>
                  </div>
                  <p className="mb-0 fw-normal">0.39%</p>
                </div>
              </div>
              <div className="mb-3">
                <p className="fw-bold">Credit cards (per transaction)</p>

                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/visa-DfUGj4HW.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Visa</p>
                  </div>
                  <p className="mb-0 fw-normal">0.8%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/maestro-CA-oqUvT.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Maestro</p>
                  </div>
                  <p className="mb-0 fw-normal">0.8%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/download.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Mastercard</p>
                  </div>
                  <p className="mb-0 fw-normal">0.8%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/download (1).png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">All other debit cards</p>
                  </div>
                  <p className="mb-0 fw-normal">0.8%</p>
                </div>
              </div>
              <div className="mb-3">
                <p className="fw-bold">International cards</p>

                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/visa-DfUGj4HW.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Visa</p>
                  </div>
                  <p className="mb-0 fw-normal">1.8%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/maestro-CA-oqUvT.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Maestro</p>
                  </div>
                  <p className="mb-0 fw-normal">1.8%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/download (2).png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">JCB Cards</p>
                  </div>
                  <p className="mb-0 fw-normal">1.8%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/americanEX-DH1CoOR3.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">American Express</p>
                  </div>
                  <p className="mb-0 fw-normal">1.8%</p>
                </div>
                <div className="d-flex justify-content-between w-100 mb-2 align-items-center">
                  <div className="d-flex gap-2 align-items-center">
                    <img
                      loading="lazy"
                      src="/assets/img/landing/unionpay-mv4XR-1o.png"
                      alt=""
                    />
                    <p className="mb-0 fw-normal">Union pay</p>
                  </div>
                  <p className="mb-0 fw-normal">1.8%</p>
                </div>
              </div>
              <div className="mt-2">
                <p>
                  All premium cards, including Cartes Bancaires, Diners Club,
                  Discover, EFTPOS Australia, Interac, and others, are subject
                  to the same charges as mentioned above.
                </p>
              </div>
              <hr />
              <div className="d-flex w-100 mb-3 flex-wrap  gap-3 justify-content-between align-items-center">
                <h4>Refund fee</h4>
                <h4>£0.50</h4>
              </div>
              <p>
                If your business exceeds £200k in annual card revenue, our team
                can assist you with tailored pricing solutions
              </p>
            </div>
          </Box>
        </Modal>
      </section>

      <section data-aos="zoom-in" className="easeir_jh bg-white">
        <div className="container ">
          <div
            className="easeir_jh bg_theme"
            style={{ padding: "30px", borderRadius: "20px" }}
          >
            <div className="row text-start align-items-center">
              <div className=" col-lg-6 ">
                <h1 className="ps-3">
                  <span className="fw-normal">A Seamless Checkout</span> <br />
                  <span className="fw-bold fst-italic iop">Experience</span>
                </h1>
              </div>
              <div className="col-lg-6">
                <div className="k">
                  <img
                    loading="lazy"
                    src="/assets/img/landing/Checkout.webp"
                    style={{ borderRadius: "10px" }}
                    className="res_img"
                    alt="All-in-one POS terminal"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="business_ty pt-3 ">
        <div className="container">
          <div>
            <h2 className="text-uppercase mb-4 mt-4">
              Adaptable Tools for Any Business
            </h2>
          </div>

          <div className="mt-4">
            <Slider {...settings2}>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage:
                      "url(../assets/img/landing/Food-drink.webp)",
                  }}
                  aria-label="Restaurant and café POS with menu customization"
                  onClick={() => router("/industries/food-drink")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Food & drink</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1 "
                  style={{
                    backgroundImage: "url(/assets/img/landing/Bar-club.webp)",
                  }}
                  aria-label="Tab and order management system"
                  onClick={() => router("/industries/bar-club")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Bar & club</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage:
                      "url(/assets/img/landing/Coffee-shop.webp)",
                  }}
                  aria-label="Quick payment processing for beverages "
                  onClick={() => router("/industries/restaurant")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Coffee shop & restaurant</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage:
                      "url(../assets/img/landing/Food-truck.webp)",
                  }}
                  aria-label="Real-time sales tracking for food vendors"
                  onClick={() => router("/industries/food-truck")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Food truck</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1 "
                  style={{
                    backgroundImage:
                      "url(/assets/img/landing/Grocery-shop.webp)",
                  }}
                  aria-label="Grocery inventory and billing software"
                  onClick={() => router("/industries/grocery")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Grocery shop</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage:
                      "url(/assets/img/landing/Market-Stall.webp)",
                  }}
                  aria-label="POS system for market stalls"
                  onClick={() => router("/industries/market-stall")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Market stall</h5>
                </div>
              </div>
              <div
                data-aos="flip-up"
                className="p-2"
                onClick={() => router("/industries/quick-service")}
              >
                <div
                  className="bstype1 "
                  style={{
                    backgroundImage:
                      "url(/assets/img/landing/Qucik-service.webp)",
                  }}
                  aria-label="Order queue and billing for QSR"
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Quick service restaurant</h5>
                </div>
              </div>
            </Slider>

            <Slider {...settings2}>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage: "url(/assets/img/landing/Retail.webp)",
                  }}
                  aria-label="Retail inventory and sales tracking"
                  onClick={() => router("/retail-pos")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Retail</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage:
                      "url(/assets/img/landing/Clothing-shop.webp)",
                  }}
                  aria-label="Apparel inventory management system"
                  onClick={() => router("/industries/clothing")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Clothing shop</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage: "url(/assets/img/landing/Gift-shop.webp)",
                  }}
                  aria-label="Barcode scanning and checkout for gift stores"
                  onClick={() => router("/industries/home-gift")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Gift shop</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage:
                      "url(/assets/img/landing/Wine-liquor.webp)",
                  }}
                  aria-label="Barcode checkout for liquor shops"
                  onClick={() => router("/industries/bar-club")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Wine & liquor</h5>
                </div>
              </div>
            </Slider>

            <Slider {...settings2}>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage:
                      "url(../assets/img/landing/Beauty-salon.webp)",
                  }}
                  aria-label="Beauty salon payment processing system"
                  onClick={() => router("/salon-pos")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Beauty salon</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1 "
                  style={{
                    backgroundImage: "url(/assets/img/landing/Charity.webp)",
                  }}
                  aria-label="POS for charities and nonprofits"
                  onClick={() => router("/retail-pos")}
                  //  onClick={() => router('/salon-pos')}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Charity</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage: "url(/assets/img/landing/Contractor.webp)",
                  }}
                  aria-label="Contractor invoicing and earnings tracking"
                  onClick={() => router("/retail-pos")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Contractor</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage: "url(../assets/img/landing/Events.webp)",
                  }}
                  aria-label="Real-time event check-in and billing system"
                  onClick={() => router("/retail-pos")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Events</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1 "
                  style={{
                    backgroundImage: "url(/assets/img/landing/Healthcare.webp)",
                  }}
                  aria-label="Medical billing and appointment POS software"
                  onClick={() => router("/retail-pos")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Healthcare</h5>
                </div>
              </div>
              <div data-aos="flip-up" className="p-2">
                <div
                  className="bstype1"
                  style={{
                    backgroundImage:
                      "url(/assets/img/landing/Membership-Organizations.webp)",
                  }}
                  aria-label="Subscription billing software"
                  onClick={() => router("/retail-pos")}
                >
                  <div className="d-flex gap-2 arrow align-items-center">
                    <small className="mb-0 text-white">Learn More</small>
                    <img
                      loading="lazy"
                      src="/assets/img/right.svg"
                      className=""
                      alt="fusion"
                    />
                  </div>
                  <h5>Membership organisation</h5>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </section>

      <section className="chwckout_exp mi-dh">
        <div className="container ">
          <div className="mb-5">
            <h2 className="lh-sm">SELL SMARTER WITH CONNECTED COMMERCE</h2>
            <p>
              A connected ecosystem built for control, speed, and growth—Fusion
              handles it all so you don’t have to.
            </p>
          </div>

          <div className="row flex-lg-row-reverse  align-items-center text-start mb-lg-5 mb-1 ">
            <div data-aos="zoom-in-left" className="col-lg-6 mb-3">
              <div>
                <img
                  loading="lazy"
                  onMouseOver={(e) =>
                    (e.currentTarget.src = "/assets/img/landing/mi1.webp")
                  }
                  onMouseOut={(e) =>
                    (e.currentTarget.src = "/assets/img/landing/mi-1.webp")
                  }
                  className="w-100"
                  alt="Mobile POS app for restaurant owners"
                  src="/assets/img/landing/mi-1.webp"
                />
              </div>
            </div>
            <div data-aos="zoom-in-right" className="col-lg-6 mb-3">
              <h3 className="fw-bold">Point of Sale Solutions</h3>
              <p>
                Run smarter, sell faster, and stay ahead with powerful POS
                software and sleek, future-ready hardware—all in one seamless
                system.
              </p>
              <div className="d-flex justify-content-start gap-2 flex-wrap">
                <button
                  onClick={() => router("/pos-system")}
                  type="button"
                  className="btn btn-sn"
                >
                  Explore Fusion POSsibilities
                </button>
              </div>
            </div>
          </div>

          <div className="row align-items-center text-start mb-lg-5 mb-1 ">
            <div data-aos="zoom-in-right" className="col-lg-6 mb-3">
              <div>
                <img
                  loading="lazy"
                  className="w-100"
                  alt="Real-time business tracking"
                  src="/assets/img/landing/mi2.webp"
                />
              </div>
            </div>
            <div data-aos="zoom-in-left" className="col-lg-6 mb-3">
              <h3 className="fw-bold">Business Card Terminal</h3>
              <p>
                Empower your business with a sleek card terminal that delivers
                fast, secure, and contactless payments—anytime, anywhere. Stay
                agile, stay ahead.
              </p>
              <div className="d-flex justify-content-start gap-2 flex-wrap">
                <button
                  onClick={() => router("/payments/proPay")}
                  type="button"
                  className="btn btn-sn "
                >
                  Get Started Now
                </button>
              </div>
            </div>
          </div>

          <div className="row flex-lg-row-reverse align-items-center text-start mb-lg-5 mb-1 ">
            <div data-aos="zoom-in-left" className="col-lg-6 mb-3">
              <div>
                <img
                  loading="lazy"
                  className="w-100"
                  alt="Track menu performance"
                  src="/assets/img/landing/mi3.webp"
                />
              </div>
            </div>
            <div data-aos="zoom-in-right" className="col-lg-6 mb-3">
              <h3 className="fw-bold">Robust Online Payments</h3>
              <p>
                Deliver a frictionless online payment experience to boost your
                bottom line with custom tailored ecommerce solutions.
              </p>
              <div className="d-flex justify-content-start gap-2 flex-wrap">
                <button
                  onClick={() => router("/payments")}
                  type="button"
                  className="btn btn-sn "
                >
                  Grow Your Online Sales
                </button>
              </div>
            </div>
          </div>

          <div className="row align-items-center text-start pb-5 ">
            <div data-aos="zoom-in-right" className="col-lg-6 mb-3">
              <div>
                <img
                  loading="lazy"
                  className="w-100"
                  alt="Restaurant operations management"
                  src="/assets/img/landing/mi4.webp"
                />
              </div>
            </div>

            <div data-aos="zoom-in-left" className="col-lg-6 mb-3">
              <h3 className="fw-bold">Business Intelligence and Analytics</h3>
              <p>
                Make data-driven business decisions with enterprise reporting
                and actionable insights at your fingertips anytime, anywhere.
              </p>
              <div className="d-flex justify-content-start gap-2 flex-wrap">
                <button
                  type="button"
                  onClick={() => router("/business-account")}
                  className="btn btn-sn"
                >
                  Get Insights
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Feedback />

      <section className="p-2 text-start global_le">
        <div data-aos="fade-down" className="container">
          <div className="w-100">
            <h1>A GLOBAL LEADER IN FINANCIAL TECHNOLOGY</h1>
          </div>

          <div className="row mt-5 text-start perse pb-2">
            <div className="col-lg-4 col-sm-6 mb-3">
              <div>
                <h1 className="fw-bolder d-md-flex justify-content-start d-none">
                  <AnimatedNumbers
                    includeComma
                    className="priceSymbol"
                    transitions={(index) => ({
                      type: "spring",
                      duration: index + 0.3,
                    })}
                    animateToNumber={8}
                    // fontStyle={{
                    //   fontSize: 74,
                    // }}
                  />
                  +
                </h1>
                <h1 className="fw-bolder mb-2 d-md-none justify-content-start d-flex">
                  8+
                </h1>
                <p>years in business</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <div>
                <h1 className="fw-bolder justify-content-start d-md-flex d-none">
                  £
                  <AnimatedNumbers
                    includeComma
                    className="priceSymbol"
                    transitions={(index) => ({
                      type: "spring",
                      duration: index + 0.3,
                    })}
                    animateToNumber={5850}
                  />
                  + Million
                </h1>
                <h1 className="fw-bolder mb-2 justify-content-start d-md-none d-flex">
                  £5850+ M
                </h1>
                <p>processed annually</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <div>
                <h1 className="fw-bolder justify-content-start d-md-flex d-none">
                  <AnimatedNumbers
                    includeComma
                    className="priceSymbol"
                    transitions={(index) => ({
                      type: "spring",
                      duration: index + 0.3,
                    })}
                    animateToNumber={94600}
                  />
                  +
                </h1>
                <h1 className="fw-bolder justify-content-start mb-2 d-md-none d-flex">
                  94,600+
                </h1>
                <p>customers</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <div>
                <h1 className="fw-bolder justify-content-start d-md-flex d-none">
                  <AnimatedNumbers
                    includeComma
                    className="priceSymbol"
                    transitions={(index) => ({
                      type: "spring",
                      duration: index + 0.3,
                    })}
                    animateToNumber={90}
                  />
                  +
                </h1>
                <h1 className="fw-bolder mb-2 justify-content-start d-md-none d-flex">
                  90+
                </h1>
                <p>technology integrations</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <div>
                <h1 className="fw-bolder justify-content-start d-md-flex d-none">
                  <AnimatedNumbers
                    includeComma
                    className="priceSymbol"
                    transitions={(index) => ({
                      type: "spring",
                      duration: index + 0.3,
                    })}
                    animateToNumber={84}
                  />
                  + Million
                </h1>
                <h1 className="fw-bolder justify-content-start mb-2 d-md-none d-flex">
                  84+ Million
                </h1>
                <p>Annual transactions</p>
              </div>
            </div>
            <div className="col-lg-4 col-sm-6 mb-3">
              <div>
                <h1 className="fw-bolder justify-content-start d-md-flex d-none">
                  <AnimatedNumbers
                    includeComma
                    className="priceSymbol"
                    transitions={(index) => ({
                      type: "spring",
                      duration: index + 0.3,
                    })}
                    animateToNumber={25}
                  />
                  +
                </h1>
                <h1 className="fw-bolder justify-content-start mb-2 d-md-none d-flex">
                  25+
                </h1>
                <p>Payment methods</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <div className="mb-5">
        <OfferProduct />
      </div>
    </>
  );
};

export default React.memo(Landing);
